export interface CompetencySpecialization {
    specializationId: string;
    name: string;
}

export interface Competency {
    cloudId: string;
    name: string;
    specializations: CompetencySpecialization[];
}

export interface CompetencyFiltersResponse {
    productCompetencies: Competency[];
    industryCompetencies: Competency[];
}

// Reject a malformed catalog as a whole; never turn an upstream error into a successful empty menu.
export function isCompetencyFiltersResponse(value: unknown): value is CompetencyFiltersResponse {
    const isRecord = (item: unknown): item is Record<string, unknown> => typeof item === 'object' && item !== null;
    const isText = (item: unknown): item is string => typeof item === 'string' && item.trim().length > 0;
    const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const isId = (item: unknown): item is string => isText(item) && uuid.test(item);
    const isGroup = (items: unknown): boolean => {
        if (!Array.isArray(items)) {
            return false;
        }
        const ids = new Set<string>();
        return items.every((item) => {
            if (!isRecord(item) || !isId(item.cloudId) || !isText(item.name) || !Array.isArray(item.specializations)) {
                return false;
            }
            if (ids.has(item.cloudId)) {
                return false;
            }
            ids.add(item.cloudId);
            const children = new Set<string>();
            return item.specializations.every((child: unknown) => {
                if (!isRecord(child) || !isId(child.specializationId) || !isText(child.name)) {
                    return false;
                }
                if (children.has(child.specializationId)) {
                    return false;
                }
                children.add(child.specializationId);
                return true;
            });
        });
    };
    return isRecord(value) && isGroup(value.productCompetencies) && isGroup(value.industryCompetencies);
}
